import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { MANAGEMENT_PRODUCTS } from '@apps-common/config/management-view'

interface IManagementViewStore {
  open: boolean
  setOpen: (open: boolean) => void
  value: string
  setValue: (value: string) => void
}

export const useManagementViewStore = create<IManagementViewStore, [['zustand/persist', unknown]]>(
  persist(
    (set, get) => ({
      open: false,
      setOpen: (open: boolean) => set(() => ({ open })),
      value: MANAGEMENT_PRODUCTS.value.toString(),
      setValue: (value: string) => {
        const isFiltered = value !== MANAGEMENT_PRODUCTS.value.toString()

        set(() => ({ value, isFiltered }))
      }
    }),
    {
      name: 'management-view',
      version: 2
    }
  )
)
